module.exports = __webpack_public_path__ + "static/img/7.b63ae7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/7.png
// module id = A3xP
// module chunks = 0